import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GeorgiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14799'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14799)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4278 14.9333H8.57068V8.39998H-0.953125V5.59998H8.57068V-0.93335H11.4278V5.59998H20.9516V8.39998H11.4278V14.9333Z'
					fill='#FF2B37'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M15.428 3.08002L14.2852 3.26669V2.33336L15.428 2.52002L15.2375 1.40002H16.1899L15.9994 2.52002L17.1423 2.33336V3.26669L15.9994 3.08002L16.1899 4.20002H15.2375L15.428 3.08002Z'
					fill='#FD0D1B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.00028 3.08002L2.85742 3.26669V2.33336L4.00028 2.52002L3.8098 1.40002H4.76218L4.57171 2.52002L5.71456 2.33336V3.26669L4.57171 3.08002L4.76218 4.20002H3.8098L4.00028 3.08002Z'
					fill='#FD0D1B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.00028 11.48L2.85742 11.6667V10.7334L4.00028 10.92L3.8098 9.80005H4.76218L4.57171 10.92L5.71456 10.7334V11.6667L4.57171 11.48L4.76218 12.6H3.8098L4.00028 11.48Z'
					fill='#FD0D1B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M15.428 11.48L14.2852 11.6667V10.7334L15.428 10.92L15.2375 9.80005H16.1899L15.9994 10.92L17.1423 10.7334V11.6667L15.9994 11.48L16.1899 12.6H15.2375L15.428 11.48Z'
					fill='#FD0D1B'
				/>
			</g>
		</svg>
	);
};

export default GeorgiaFlagIcon;
